import React from 'react';
import styled from 'styled-components';

const Container = styled.main`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: clamp(var(--spacing-6), 4vw, var(--spacing-12));
  width: 100%;
  max-width: 100%;
  padding: 0 0 clamp(var(--spacing-6), 4vw, var(--spacing-12));
  margin: 0;
  overflow: visible;
  background: transparent;
  scroll-behavior: smooth;
  -webkit-overflow-scrolling: touch;
  box-sizing: border-box;
  
  @media (max-width: 48rem) { /* --breakpoint-tablet */
    gap: var(--spacing-6);
    padding: 0 0 var(--spacing-6);
  }
  
  @media (max-width: 30rem) { /* --breakpoint-mobile */
    gap: var(--spacing-4);
    padding: 0 0 var(--spacing-4);
  }
  
  /* Only constrain width on ultra-wide screens */
  @media (min-width: 120rem) { /* 1920px */
    max-width: var(--container-wide);
    margin: 0 auto;
  }
`;

interface PageContainerProps {
  children: React.ReactNode;
  className?: string;
}

export const PageContainer: React.FC<PageContainerProps> = ({ children, className }) => {
  return (
    <Container className={className}>
      {children}
    </Container>
  );
};

